import {useEffect, useState} from 'react';

export function useNow(interval = 60 * 1000): number | undefined {
	const [now, setNow] = useState<number>();

	useEffect(() => {
		setNow(Date.now());
		const timer = setInterval(() => setNow(Date.now()), interval);
		return () => clearInterval(timer);
	}, [interval]);

	return now;
}
